import { RouteObject } from "react-router-dom";
import {
  dashboards,
  planners,
  opportunities,
  performance,
  health,
  infrastructure,
  security,
  adminConsole,
  admin,
  finOps,
  onBoarding,
  configuration,
} from "./privateRouteCategories";

const privateRoutes: RouteObject[] = [
  ...dashboards,
  ...planners,
  ...opportunities,
  ...performance,
  ...health,
  ...infrastructure,
  ...security,
  ...adminConsole,
  ...admin,
  ...finOps,
  ...onBoarding,
  ...configuration,
];

export default privateRoutes;
